import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from '../../hook-utils';
import { TaskItemAction } from '../../model';
import { actions } from '../../store';
import { getFacebookPostById } from '../../store/reducers/facebook';
import Modal from '../Modal';
import { CallViewByItemDetails } from './CallDetailsPanel';
import FacebookView from './FacebookView';


export interface ShowTweetState {
  activityId: string
}

export default function FacebookViewPanelByActivityId({ activityId, onClose }: { activityId: string, onClose(tweetId: string): void }) {
  const facebook = useSelector(s => getFacebookPostById(s, activityId) )
  const dispatch = useDispatch()

  useEffect(() => {
    if (activityId === '') { return }
    dispatch(actions.fetchFacebookPostsRequest(activityId, ''))
  }, [dispatch, activityId])

  function handleClose() {
    if (facebook)
      dispatch(actions.removeMediaItem(activityId))
  }

  if (!facebook) { return null }

  const customStyles = {
    content: {
      width: '50%',
      height: '70%',
    },
  };

  return <Modal style={customStyles} isOpen={true} className='EmailModal'>
    <CallViewByItemDetails itemId={activityId} itemType='FB' itemAction={TaskItemAction.none} onClose={() => {
      handleClose()
    }} />
    <FacebookViewPanel activityId={activityId}  onClose={() => {
      handleClose()
    }} />
  </Modal>
}

export function FacebookViewPanel({ activityId, onClose }: { activityId: string, onClose?(activityId: string): void }) {
  const facebook = useSelector(s => getFacebookPostById(s, activityId) )
  const dispatch = useDispatch()

  useEffect(() => {
    if (activityId === '') { return }
    dispatch(actions.fetchFacebookPostsRequest(activityId, ''))
  }, [dispatch, activityId])

  if (!facebook) { return null }

  return <FacebookView activityId={activityId} queueId='' />
}
